import TransportPointCreate from "../components/views/transportPoint/transportPointCreate.vue";
import Transport from "../components/views/transportPoint/transport.vue";

const routes = [
  {
    path: "transport",
    component: Transport,
    name: "transport",
    meta: {
      description: "List of Transfer Points",
      title: "Transfer Point",
      requiresAuth: true,
    },
  },
  {
    path: "transport/transportPointCreate/:_id",
    component: TransportPointCreate,
    name: "transportPointCreate",
    meta: {
      // description: 'Add a new Transfer Point',
      title: "Add / Update Transfer Point",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/transport.route.js